import { useContextedGoneError } from '../composables/use-contexted-gone-error';
import { features, Decisions } from '../utils';

export default defineNuxtRouteMiddleware(async (to, from) => {
  // STORY_NEW_UNAVAILABLE_PAGE
  // TODO: Remove if below

  if (!features.isEnabled(Decisions.STORY_NEW_UNAVAILABLE_PAGE)) return;

  const { isGoneRoute, navigateToGone, shouldGoneError } = useContextedGoneError();

  if (!shouldGoneError(to)) return;

  if (isGoneRoute(from) && isGoneRoute(to)) {
    clearError();

    return;
  }

  if (!isGoneRoute(from) && isGoneRoute(to)) return;

  return navigateToGone(to);
});
